import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, Stack, TableCell, TableRow, useTheme } from '@mui/material';
import { ReactNode, type FC } from 'react';

type SectionHeaderProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  expandable: boolean;
  indent?: number;
  cells?: ReactNode;
  children: ReactNode;
};

const SectionHeader: FC<SectionHeaderProps> = ({ open, setOpen, expandable, indent, cells, children }) => {
  const theme = useTheme();

  return (
    <TableRow
      onClick={() => setOpen(!open)}
      sx={{ cursor: 'pointer', bgcolor: theme.palette.action.selected, '&:hover': { opacity: '80%' } }}
    >
      <TableCell colSpan={cells ? 1 : 3} size='small'>
        <Stack direction='row' pl={indent} gap={1} alignItems='center'>
          {expandable && (
            <IconButton size='small' sx={{ p: 0.25 }}>
              {open ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
            </IconButton>
          )}
          {children}
        </Stack>
      </TableCell>
      {cells}
    </TableRow>
  );
};

export default SectionHeader;
